var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c("el-form", { attrs: { size: "small", "label-position": "top" } }, [
            _c(
              "div",
              { staticClass: "searchContainer" },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "template",
                              { slot: "label" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      height: "28px",
                                    },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "operationCenter.PleaseSelect"
                                      ),
                                    },
                                    model: {
                                      value: _vm.queryForm.params.timeField,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "timeField",
                                          $$v
                                        )
                                      },
                                      expression: "queryForm.params.timeField",
                                    },
                                  },
                                  _vm._l(_vm.dateTime, function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "start-placeholder": _vm.$t(
                                  "operationCenter.startDate"
                                ),
                                "end-placeholder": _vm.$t(
                                  "operationCenter.endDate"
                                ),
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                clearable: "",
                                "picker-options": _vm.pickerOptions,
                                "default-time": ["00:00:00", "23:59:59"],
                              },
                              model: {
                                value: _vm.data,
                                callback: function ($$v) {
                                  _vm.data = $$v
                                },
                                expression: "data",
                              },
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("basicData.status") } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "operationCenter.PleaseSelect"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.queryForm.params.status,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "status",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.params.status",
                                },
                              },
                              _vm._l(_vm.STATUS, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("basicData.ExpenseType") } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "receivablePayable.InputFuzzyMatching"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.expenseType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "expenseType",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.expenseType",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("receivablePayable.CostCenter"),
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "receivablePayable.InputFuzzyMatching"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.costCenter,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "costCenter",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.costCenter",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("receivablePayable.Region"),
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "receivablePayable.InputFuzzyMatching"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.area,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "area", $$v)
                                },
                                expression: "queryForm.params.area",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("GlobalSetObj.Estado") } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "receivablePayable.InputFuzzyMatching"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.state,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "state", $$v)
                                },
                                expression: "queryForm.params.state",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("basicData.Outlets") } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "receivablePayable.InputFuzzyMatching"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.station,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "station", $$v)
                                },
                                expression: "queryForm.params.station",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "receivablePayable.ApprovalFormNumber"
                              ),
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "receivablePayable.InputFuzzyMatching"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.serialNumber,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "serialNumber",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.serialNumber",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", icon: "el-icon-search" },
              on: { click: _vm.handleQuery },
            },
            [_vm._v(_vm._s(_vm.$t("newOrder.search")))]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-refresh-left" },
              on: { click: _vm.onReset },
            },
            [_vm._v(" " + _vm._s(_vm.$t("operationCenter.reset")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticClass: "table-but" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value:
                        "btn:finance:reportDashboard:feishu:paymentDetails:exchangeRate",
                      expression:
                        "'btn:finance:reportDashboard:feishu:paymentDetails:exchangeRate'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.asyncExchangeRate },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("receivablePayable.ExchangeRateMaintenance"))
                  ),
                ]
              ),
              _c(
                "el-popover",
                { attrs: { placement: "bottom-start", trigger: "hover" } },
                [
                  _c(
                    "div",
                    { staticClass: "feet" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permit",
                              rawName: "v-permit:remove",
                              value:
                                "btn:finance:reportDashboard:feishu:paymentDetails:export",
                              expression:
                                "'btn:finance:reportDashboard:feishu:paymentDetails:export'",
                              arg: "remove",
                            },
                          ],
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.asyncApiStatisticsExport(1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("basicData.ExportOnlyListData")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permit",
                              rawName: "v-permit:remove",
                              value:
                                "btn:finance:reportDashboard:feishu:paymentDetails:exportAll",
                              expression:
                                "'btn:finance:reportDashboard:feishu:paymentDetails:exportAll'",
                              arg: "remove",
                            },
                          ],
                          staticClass: "feet-btn",
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.asyncApiStatisticsExport(2)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("basicData.FullExportWithAttachments")
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        slot: "reference",
                        size: "small",
                        icon: "el-icon-download",
                      },
                      slot: "reference",
                    },
                    [_vm._v(_vm._s(_vm.$t("receivablePayable.Export")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticClass: "table-height",
              attrs: {
                data: _vm.tableData,
                border: "",
                height: _vm.tableHeightRow.height,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("operationCenter.ind"),
                  width: "80px",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.queryForm.pageNumber - 1) *
                                _vm.queryForm.pageSize +
                                scope.$index +
                                1
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._l(_vm.Table_Column, function (item) {
                return [
                  _c("el-table-column", {
                    key: item.code,
                    attrs: {
                      label: item.label,
                      "min-width": item.width,
                      prop: item.prop,
                      "class-name": item.className,
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              item.prop === "status"
                                ? _c(
                                    "span",
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: _vm.STATUS[scope.row.status]
                                              ? _vm.STATUS[scope.row.status]
                                                  .type
                                              : "info",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.STATUS[scope.row.status]
                                                  .label || "-"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : item.prop === "attachmentList"
                                ? _c("span", [
                                    _c(
                                      "div",
                                      { staticClass: "flex fileView" },
                                      [
                                        scope.row.attachmentList &&
                                        scope.row.attachmentList.length > 0
                                          ? [
                                              _vm._l(
                                                _vm.getDisplayFiles(
                                                  scope.row.attachmentList
                                                ),
                                                function (key, index) {
                                                  return _c(
                                                    "el-link",
                                                    {
                                                      key: key.id,
                                                      attrs: {
                                                        type: "success",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.previewFile(
                                                            scope.row,
                                                            _vm.getOriginalIndex(
                                                              scope.row
                                                                .attachmentList,
                                                              key
                                                            )
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(key.fileName)
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              scope.row.attachmentList.length >
                                              3
                                                ? _c(
                                                    "el-popover",
                                                    {
                                                      attrs: {
                                                        placement:
                                                          "bottom-start",
                                                        trigger: "hover",
                                                        "popper-class":
                                                          "file-list-popover",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "file-list-container",
                                                        },
                                                        _vm._l(
                                                          scope.row
                                                            .attachmentList,
                                                          function (file, idx) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key: file.id,
                                                                staticClass:
                                                                  "file-item",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleFileClick(
                                                                        scope.row,
                                                                        idx
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-link",
                                                                  {
                                                                    attrs: {
                                                                      type: "success",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        file.fileName
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                      _c(
                                                        "el-link",
                                                        {
                                                          attrs: {
                                                            slot: "reference",
                                                            type: "primary",
                                                          },
                                                          slot: "reference",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "...(" +
                                                              _vm._s(
                                                                scope.row
                                                                  .attachmentList
                                                                  .length - 3
                                                              ) +
                                                              ")"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(scope.row[item.prop])),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ]
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("basicData.operate"),
                  align: "center",
                  width: "140",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value:
                                  "btn:finance:reportDashboard:feishu:paymentDetails:exportAttachment",
                                expression:
                                  "'btn:finance:reportDashboard:feishu:paymentDetails:exportAttachment'",
                                arg: "remove",
                              },
                            ],
                            attrs: { plain: "", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.exportFile(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("basicData.ExportAttachments"))
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.queryForm.pageNumber,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.queryForm.pageSize,
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.getPageNumber,
                  "size-change": _vm.getPageSize,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.exchangeRateDialogVisible,
            direction: "ltr",
            size: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.exchangeRateDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "drawer_title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("h4", { staticStyle: { margin: "0" } }, [
                _vm._v(
                  _vm._s(_vm.$t("receivablePayable.ExchangeRateMaintenance"))
                ),
              ]),
              _c("div", { staticClass: "tips" }, [
                _c("i", { staticClass: "el-icon-warning-outline" }),
                _vm._v(
                  " " + _vm._s(_vm.$t("receivablePayable.BaseCurrencyIsBrl"))
                ),
              ]),
            ]
          ),
          _c("ExchangeRateForm", {
            ref: "exchangeRateFormRef",
            on: { close: _vm.close },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }